/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import CustomTable from "../../../components/CustomTable";
import { apiURL, fetchApi } from "../../../redux/api";

function SupportingDocumentsPv({ pvInfo }) {
  const [attachmentList, setPvAttachmentList] = useState([]);

  useEffect(() => {
    if (pvInfo && pvInfo.length) {
      fetchApi(`fetch-pv-images?pv_code=${pvInfo[0].pv_code}`).then((resp) => {
        if (resp.results && resp.results.length) {
          setPvAttachmentList(resp.results);
        }
      });
    }
  }, [pvInfo]);

  const uploadItems = attachmentList.filter(
    (item) => !item.upload_type || item.upload_type === "upload"
  );
  const cvItems = attachmentList.filter(
    (item) => item.upload_type === "cv"
  );

  const fileField = [
    {
      title: "File Name",
      custom: true,
      component: (item) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.open(`${apiURL}/uploads/${item.image_url}`, "_blank");
          }}
        >
          {item.image_url}
        </a>
      ),
    },
  ];

  return (
    <div className="my-4">
      {uploadItems.length > 0 && (
        <>
          <h5>Supporting Documents</h5>
          <CustomTable fields={fileField} data={uploadItems} />
        </>
      )}

      {cvItems.length > 0 && (
        <div className="mt-4">
          <h5>Certificate of Validation (CV)</h5>
          <CustomTable fields={fileField} data={cvItems} />
        </div>
      )}
    </div>
  );
}

export default SupportingDocumentsPv;
